<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>网站配置</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item to="/config/quick">快捷连接</el-breadcrumb-item>
        <el-breadcrumb-item>快捷连接列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>快捷连接列表</span>
        </div>
        <span class="xcx-add left font14" @click="dialogFormVisible = true">添加快捷连接</span>
      </div>
      <div class="search-box mt10">
        <el-form :inline="true">
          <el-form-item>
            <el-input placeholder="请输入关键词" v-model="search.keys"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" stripe style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" width="100"></el-table-column>
          <el-table-column label="图标" width="80">
            <template slot-scope="scope">
              <img :src="scope.row.thumb" height="40" width="40" />
            </template>
          </el-table-column>
          <el-table-column prop="zh_title" label="中文" width="200"></el-table-column>
          <el-table-column prop="en_title" label="英语"></el-table-column>
          <el-table-column prop="sort" label="排序" width="50"></el-table-column>
          <el-table-column label="操作" width="160">
            <template #default="scope">
              <el-button size="mini" @click="edit(scope.row.id)">编辑</el-button>
              <el-button size="mini" type="danger" @click="del_item(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination
            class="left"
            @current-change="handleCurrentChange"
            :current-page="page"
            background
            layout="prev, pager, next"
            :total="count"
          ></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="菜单管理" :visible.sync="dialogFormVisible">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="显示图标：" :label-width="formLabelWidth" prop="thumb" class="banner_img">
          <el-upload
            class="avatar-uploader"
            accept="image/*"
            name="image"
            :action="upload_img_url"
            :show-file-list="false"
            :on-success="handleAvatarSuccess2"
          >
            <img v-if="ruleForm.thumb" :src="ruleForm.thumb" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="font-size: 12px; color: #606266">建议尺寸 80 X 80，或等比例缩放</div>
        </el-form-item>
        <el-form-item label="选中图标：" :label-width="formLabelWidth" prop="thumb_m" class="banner_img">
          <el-upload
            class="avatar-uploader"
            accept="image/*"
            name="image"
            :action="upload_img_url"
            :show-file-list="false"
            :on-success="handleAvatarSuccess1"
          >
            <img v-if="ruleForm.thumb_m" :src="ruleForm.thumb_m" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="font-size: 12px; color: #606266">建议尺寸 80 X 80，或等比例缩放</div>
        </el-form-item>

        <el-form-item label="分类名称(中文)：" :label-width="formLabelWidth" prop="zh_title">
          <el-input v-model="ruleForm.zh_title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="分类名称(英文)：" :label-width="formLabelWidth">
          <el-input v-model="ruleForm.en_title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="连接地址：" :label-width="formLabelWidth">
          <el-input v-model="ruleForm.en_title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="分类排序" :label-width="formLabelWidth">
          <el-input v-model="ruleForm.sort" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      id: "",
      tableData: [],
      cateList: [],
      page: 0,
      count: 0,
      limit: 10,
      dialogFormVisible: false,
      upload_img_url: this.adminApi.upload_url,
      ruleForm: {
        pid: "",
        thumb: "",
        thumb_m: "",
        zh_title: "",
        en_title: "",
        link: "",
        sort: "",
      },
      search: {
        keys: "",
      },
      rules: {
        pid: [{ required: true, message: "请选择分类", trigger: "change" }],
        thumb: [
          {
            required: true,
            message: "请上传图片",
            trigger: "blur",
          },
        ],
        zh_title: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      formLabelWidth: "150px",
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
  },
  methods: {
    getIndex() {
      this.getList();
    },
    getClearIndex() {
      this.search.keys = "";
      this.getList();
    },
    handleAvatarSuccess1(res, file) {
      console.log(res);
      this.ruleForm.thumb_m = res.msg;
    },
    handleAvatarSuccess2(res, file) {
      console.log(res);
      this.ruleForm.thumb = res.msg;
    },
    edit(ids) {
      var that = this;
      that.id = ids;
      that.axios.post("/quick/edit", { id: ids }).then((res) => {
        if (res) {
          that.ruleForm = res.data;
          that.dialogFormVisible = true;
        }
      });
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post("/quick/destroy", {
              ids: ids,
            })
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                that.getList();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            });
        })
        .catch(() => { });
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      formData.keys = that.search.keys;
      that.axios.post("/quick/index", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
        }
        that.loading = false;
      });
    },
    /**
     * 提交信息
     */
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.ruleForm;
        var url = "/quick/store";
        if (that.id) {
          formData.id = that.id;
          url = "/quick/update";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.ruleForm.pid = "";
          that.ruleForm.thumb = "";
          that.ruleForm.thumb_m = "";
          that.ruleForm.zh_title = "";
          that.ruleForm.en_title = "";
          that.ruleForm.link = "";
          that.ruleForm.sort = "";
          that.dialogFormVisible = false;
          that.getList();
        });
      });
    },
  },
};
</script>
<style>
.search-box {
  padding: 0 20px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>